import { render, staticRenderFns } from "./_study.vue?vue&type=template&id=2f0cab9d&scoped=true"
import script from "./_study.vue?vue&type=script&lang=js"
export * from "./_study.vue?vue&type=script&lang=js"
import style0 from "./_study.vue?vue&type=style&index=0&id=2f0cab9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0cab9d",
  null
  
)

export default component.exports